export const getDate = (date: Date) => date.getDate();
